import appConfigStoreModule from '@core/@app-config/appConfigStoreModule'
import Vue from 'vue'
import Vuex from 'vuex'
import app from './app'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    appConfig: appConfigStoreModule,
    app,
  },
})

window.addEventListener('storage', (event) => {
  if (event.key === 'cart_editingOrderNo') {
    const newValue = JSON.parse(event.newValue);
    store.commit('app/cart/setEditingOrderNo', newValue);
  }
});

export default store;
